import { v4 as uuidv4 } from 'uuid';

const THREAD_ID_KEY = 'rag_thread_id';

const loadThreadId = () => {
  try { return localStorage.getItem(THREAD_ID_KEY) || null; } catch { return null; }
};

const saveThreadId = (id) => {
  try { localStorage.setItem(THREAD_ID_KEY, id); } catch { /* ignore */ }
};

// Actions
export const CHAT_OPEN = 'chat/open';
export const CHAT_CLOSE = 'chat/close';
export const CHAT_ADD_MESSAGE = 'chat/addMessage';
export const CHAT_STREAM_START = 'chat/streamStart';
export const CHAT_STREAM_TOKEN = 'chat/streamToken';
export const CHAT_STREAM_DONE = 'chat/streamDone';
export const CHAT_STREAM_ERROR = 'chat/streamError';
export const CHAT_SET_PROGRESS = 'chat/setProgress';
export const CHAT_SET_THREAD = 'chat/setThread';
export const CHAT_CLEAR = 'chat/clear';

// Action creators
export const openChat = () => ({ type: CHAT_OPEN });
export const closeChat = () => ({ type: CHAT_CLOSE });

export const addUserMessage = (content) => ({
  type: CHAT_ADD_MESSAGE,
  payload: { id: uuidv4(), role: 'user', content, timestamp: Date.now() }
});

export const startStream = () => ({ type: CHAT_STREAM_START });
export const appendToken = (token) => ({ type: CHAT_STREAM_TOKEN, payload: token });
export const finishStream = (threadId) => ({ type: CHAT_STREAM_DONE, payload: threadId });
export const setStreamError = (message) => ({ type: CHAT_STREAM_ERROR, payload: message });
export const setProgressStep = (step, message) => ({ type: CHAT_SET_PROGRESS, payload: { step, message } });
export const setThreadId = (id) => ({ type: CHAT_SET_THREAD, payload: id });
export const clearChat = () => ({ type: CHAT_CLEAR });

// Initial state
const initialState = {
  isOpen: false,
  messages: [],
  isStreaming: false,
  currentStreamText: '',
  threadId: loadThreadId(),
  progressStep: 0,
  progressMessage: '',
  hasUnread: false,
};

// Reducer
export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case CHAT_OPEN:
      return { ...state, isOpen: true, hasUnread: false };

    case CHAT_CLOSE:
      return { ...state, isOpen: false };

    case CHAT_ADD_MESSAGE:
      return { ...state, messages: [...state.messages, action.payload] };

    case CHAT_STREAM_START:
      return { ...state, isStreaming: true, currentStreamText: '', progressStep: 0, progressMessage: '' };

    case CHAT_STREAM_TOKEN:
      return { ...state, currentStreamText: state.currentStreamText + action.payload };

    case CHAT_STREAM_DONE: {
      const botMessage = {
        id: uuidv4(),
        role: 'bot',
        content: state.currentStreamText,
        timestamp: Date.now(),
        isExpanded: false,
      };
      const newThreadId = action.payload || state.threadId;
      if (newThreadId) saveThreadId(newThreadId);
      return {
        ...state,
        isStreaming: false,
        currentStreamText: '',
        progressStep: 0,
        progressMessage: '',
        threadId: newThreadId,
        messages: [...state.messages, botMessage],
        hasUnread: !state.isOpen,
      };
    }

    case CHAT_STREAM_ERROR: {
      const errorMessage = {
        id: uuidv4(),
        role: 'bot',
        content: action.payload,
        timestamp: Date.now(),
        isExpanded: false,
        isError: true,
      };
      return {
        ...state,
        isStreaming: false,
        currentStreamText: '',
        progressStep: 0,
        progressMessage: '',
        messages: [...state.messages, errorMessage],
      };
    }

    case CHAT_SET_PROGRESS:
      return { ...state, progressStep: action.payload.step, progressMessage: action.payload.message };

    case CHAT_SET_THREAD: {
      saveThreadId(action.payload);
      return { ...state, threadId: action.payload };
    }

    case CHAT_CLEAR:
      return { ...initialState, isOpen: state.isOpen, hasUnread: false };

    default:
      return state;
  }
}
